"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ItemResponses;

(function (ItemResponses) {
  var DeliveryItemListingResponse =
  /** @class */
  function () {
    /**
    * Response containing multiple item
    * @constructor
    * @param {TItem[]} items - Collection of content items
    * @param {Pagination} pagination - Pagination object
    * @param {ContentItem[]} linkedItems - Content items that were processed during request
    * @param {ICloudResponseDebug} debug - Debug information from the request
    */
    function DeliveryItemListingResponse(items, pagination, linkedItems, debug) {
      this.items = items;
      this.pagination = pagination;
      this.linkedItems = linkedItems;
      this.debug = debug;
      this.isEmpty = this.getIsEmpty();
      this.lastItem = this.getLastItem();
      this.firstItem = this.getFirstItem();
    }

    DeliveryItemListingResponse.prototype.getIsEmpty = function () {
      if (!this.items) {
        return true;
      }

      return this.items.length <= 0;
    };

    DeliveryItemListingResponse.prototype.getFirstItem = function () {
      if (!this.items) {
        return;
      }

      if (this.items.length < 1) {
        return;
      }

      return this.items[0];
    };

    DeliveryItemListingResponse.prototype.getLastItem = function () {
      if (!this.items) {
        return;
      }

      if (this.items.length < 1) {
        return;
      }

      return this.items[this.items.length - 1];
    };

    return DeliveryItemListingResponse;
  }();

  ItemResponses.DeliveryItemListingResponse = DeliveryItemListingResponse;

  var DeliveryItemResponse =
  /** @class */
  function () {
    /**
    * Response containing single item
    * @constructor
    * @param {TItem} item - Returned item
    * @param {ContentItem[]} linkedItems - Content items that were processed during request
    * @param {ICloudResponseDebug} debug - Debug information from the request
    */
    function DeliveryItemResponse(item, linkedItems, debug) {
      this.item = item;
      this.linkedItems = linkedItems;
      this.debug = debug;
      this.isEmpty = this.getIsEmpty();
    }

    DeliveryItemResponse.prototype.getIsEmpty = function () {
      if (!this.item) {
        return true;
      }

      return false;
    };

    return DeliveryItemResponse;
  }();

  ItemResponses.DeliveryItemResponse = DeliveryItemResponse;
})(ItemResponses = exports.ItemResponses || (exports.ItemResponses = {}));